<header class="page-header">
	<div class="flex items-center">
		<h2 class="mr-3">Billing</h2>
		<p>provided by</p>
		<img
			src="/assets/images/stripe-logo.png"
			alt="Stripe"
			style="max-width: 100px"
		/>
	</div>
</header>

<app-container class="max-w-500 mb-6 mt-10">
	<p>
		<strong>Note:</strong> You will be redirected to
		<a
			externalNavInterceptor
			href="https://stripe.com/"
			class="underline"
			target="_blank"
			rel="nofollow noreferrer noindex"
			>Stripe</a
		>'s website to fill in your credit card details. Your details are safely
		stored with Stripe. LawLabs Inc. does not store any credit card information
		on our platform.
	</p>
</app-container>

<app-container
	*ngIf="errorCreatingStripeCustomer"
	class="max-w-500 border-red-dark bg-red-lighter text-red-dark mb-6"
>
	<h3 class="mb-3">There was an error.</h3>
	<p class="mb-3">
		Sorry, we encountered an error creating a Stripe customer account for your
		business. Please refresh the page to try again. If that fails, please
		<a emailLinkInterceptor href="mailto:support@lawlabs.ca">contact support</a
		>.
	</p>
	<p>{{ errorCreatingStripeCustomer }}</p>
</app-container>

<!-- this is only visible if the customer is saved with stripe -->
<div class="flex max-w-500 mb-6 items-end">
	<app-input-wrapper label="Billing Email">
		<app-input
			class="mr-6"
			[formControl]="emailControl"
			type="email"
		></app-input>
	</app-input-wrapper>
	<app-button
		*ngIf="emailControl.value?.length && emailControl.dirty"
		[disabled]="(processing$ | async) || emailControl.invalid"
		(click)="saveEmail()"
		[loading]="saving$ | async"
		>Save</app-button
	>
</div>
<div class="flex items-center gap-10">
	<app-button
		[disabled]="disableStripeButton$ | async"
		[loading]="loading$ | async"
		(onClick)="getBillingPortalRedirectURL()"
		>Take me to the Stripe billing portal</app-button
	>

	<div *ngIf="balance$ | async as balance" class="flex gap-3">
		<span>Balance:</span
		><span [class.credit]="balance >= 0" [class.credit-neg]="balance < 0"
			>{{ balance | centsToDollars }} <span *ngIf="balance > 0"> CR</span
			><span *ngIf="balance < 0">owed</span></span
		>
	</div>
</div>

<ng-container *ngIf="invoices$ | async as invoices">
	<ng-container *ngIf="invoices.rows?.length">
		<h3 class="mt-6 mb-6">Recent Invoices</h3>
		<table
			class="dashboard-table small row-select"
			*ngIf="invoices?.rows?.length"
		>
			<tbody>
				<tr>
					<th class="text-left">Created Date</th>
					<th class="text-right">Total Items</th>
					<th class="text-right">Total Amount</th>
					<th class="text-left">Status</th>
				</tr>
				<tr *ngFor="let invoice of invoices.rows">
					<td>{{ invoice.created * 1000 | date: 'short' }}</td>
					<td class="text-right">{{ invoice.lines.data?.length }}</td>
					<td class="text-right">
						{{ invoice.total | centsToDollars }}
						<span class="uppercase">{{ invoice.currency }}</span>
					</td>
					<td class="capitalize">{{ invoice.status | stripeInvoiceStatus }}</td>
				</tr>
			</tbody>
		</table>
	</ng-container>
</ng-container>
